let validatorMap = {
  'isExternal':{
    name:"是否外部的资源",
    validator(path){
      return /^(https?:|mailto:|tel:)/.test(path)
    }
  },
  'isNull': {
    name:"是否为空",
    validator(value) {
      let v = value;
      if (IDM.type(v) == 'string') {
        v = v.trim();
      }
      if (v === '' || v == "[]"|| v == "{}") {
        return true;
      } else if (IDM.type(v) == 'object' && IDM.isEmptyObject(v)) {
        return true;
      } else if (IDM.type(v) == 'array' && v.length == 0) {
        return true;
      } else if (IDM.isUnDef(v)) {
        return true;
      }
      return false;
    }
  },
  //验证是否是一个数字
  "isNumber": {
    name:"是否是一个数字",
    validator(value, precision) {
      let reg = null;
      if (precision && precision > 0) {
        reg = new RegExp("^-?([0-9]\\d*|0(?!\\.0+$))(\\.\\d{1," + precision + "})?$", 'ig');
      } else {
        reg = new RegExp("^-?[0-9]\\d*$", 'ig');
      }
      if (!reg.test(value)) {
        return false;
      }
      return true;
    }
  },
  //验证是否是一个字符串
  "isString": {
    name:"是否是一个字符串",
    validator(value) {
      if (typeof value === 'string' || value instanceof String) {
        return true
      }
      return false
    }
  },
  //验证是否是一个数组
  "isArray": {
    name:"是否是一个数组",
    validator(arg) {
      if (typeof Array.isArray === 'undefined') {
        return Object.prototype.toString.call(arg) === '[object Array]'
      }
      return Array.isArray(arg)
    }
  },
  //验证数字是否超出
  "isNumberOver": {
    name:"是否超出指定数字",
    validator(value, ceil) {
      value = parseFloat(value);
      ceil = parseFloat(ceil);
      if (value > ceil) {
        return true;
      }
      return false;
    }
  },
  //验证数字是否小于
  "isNumberUnder":{
    name:"是否小于指定数字",
    validator(value, floor) {
      value = parseFloat(value);
      floor = parseFloat(floor);
      if (value < floor) {
        return true;
      }
      return false;
    }
  },
  //验证数字精度
  "precision":{
    name:"数字精度",
    validator(value, precision) {
      value = value.toString();
      const reg = new RegExp("^-?([0-9]\\d*|0(?!\\.0+$))(\\.\\d{1," + precision + "})?$", 'ig');
      if (!reg.test(value)) {
        return false;
      }
      return true;
    }
  },
  "maxLength":{
    name:"字符串超出指定长度",
    validator(value,maxlength){
      if(value.length>maxlength){
        return true;
      }
      return false;
    }
  },
  "minLength":{
    name:"字符小于指定长度",
    validator(value,minLength){
      if(value.length<minLength){
        return true;
      }
      return false;
    }
  },
  //身份证号码
  'isIDCard': {
    name:"身份证号码",
    type:"express",
    validator(value) {
      //身份证正则表达式(15位)
      const isIDCard1 = /^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$/;
      //身份证正则表达式(18位)
      const isIDCard2 = /^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X)$/;
      if (!isIDCard1.test(value) && !isIDCard2.test(value)) {
        return false;
      }
      return true;
    }
  },
  //是否是手机
  'isMobile': {
    name:"手机号码",
    type:"express",
    validator(value) {
      var reg = /^1(3|4|5|7|8|9|6)\d{9}$/;
      if (!reg.test(value)) {
        return false;
      }
      return true;
    }
  },
  //是否是座机
  "isTelPhone": {
    name:"座机号码",
    type:"express",
    validator(value) {
      var reg = /^(0\d{2,3}-)?\d{7,8}$/;
      if (!reg.test(value)) {
        return false;
      }
      return true;
    }
  },
  //是否是手机或座机
  "isMobileOrTelPhone": {
    name:"手机/座机号码",
    type:"express",
    validator(value) {
      var mobile = /^1(3|4|5|7|8|9|6)\d{9}$/;
      var tel = /^(0\d{2}-)?\d{7,8}$/;
      if (!mobile.test(value) && !tel.test(value)) {
        return false;
      }
      return true;
    }
  },
  //电子邮箱
  'isEmail': {
    name:"电子邮箱",
    type:"express",
    validator(value) {
      var reg = /\w+((-w+)|(\.\w+))*\@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z0-9]+/;
      if (!reg.test(value)) {
        return false;
      }
      return true;
    }
  },
  "isPlateNumber": {
    name:"车牌号码",
    type:"express",
    validator(value) {
      var reg = /(^[\u4E00-\u9FA5]{1}[A-Z0-9]{6}$)|(^[A-Z]{2}[A-Z0-9]{2}[A-Z0-9\u4E00-\u9FA5]{1}[A-Z0-9]{4}$)|(^[\u4E00-\u9FA5]{1}[A-Z0-9]{5}[挂学警军港澳]{1}$)|(^[A-Z]{2}[0-9]{5}$)|(^(08|38){1}[A-Z0-9]{4}[A-Z0-9挂学警军港澳]{1}$)/;
      if (reg.test(value)) {
        return false;
      }
      return true;
    }
  },
  //是否网址
  'isUrl': {
    name:"网址",
    type:"express",
    validator(value) {
      var reg = new RegExp('^(?!mailto:)(?:(?:http|https|ftp)://|//)(?:\\S+(?::\\S*)?@)?(?:(?:(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}(?:\\.(?:[0-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))|(?:(?:[a-z\\u00a1-\\uffff0-9]+-?)*[a-z\\u00a1-\\uffff0-9]+)(?:\\.(?:[a-z\\u00a1-\\uffff0-9]+-?)*[a-z\\u00a1-\\uffff0-9]+)*(?:\\.(?:[a-z\\u00a1-\\uffff]{2,})))|localhost)(?::\\d{2,5})?(?:(/|\\?|#)[^\\s]*)?$', 'i');
      if (!reg.test(value)) {
        return false;
      }
      return true;
    }
  },
  //是否ip地址
  'isIpAddress': {
    name:"ip地址",
    type:"express",
    validator(value) {
      var reg = /((^\s*((([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5]))\s*$)|(^\s*((([0-9A-Fa-f]{1,4}:){7}([0-9A-Fa-f]{1,4}|:))|(([0-9A-Fa-f]{1,4}:){6}(:[0-9A-Fa-f]{1,4}|((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){5}(((:[0-9A-Fa-f]{1,4}){1,2})|:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){4}(((:[0-9A-Fa-f]{1,4}){1,3})|((:[0-9A-Fa-f]{1,4})?:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){3}(((:[0-9A-Fa-f]{1,4}){1,4})|((:[0-9A-Fa-f]{1,4}){0,2}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){2}(((:[0-9A-Fa-f]{1,4}){1,5})|((:[0-9A-Fa-f]{1,4}){0,3}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){1}(((:[0-9A-Fa-f]{1,4}){1,6})|((:[0-9A-Fa-f]{1,4}){0,4}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(:(((:[0-9A-Fa-f]{1,4}){1,7})|((:[0-9A-Fa-f]{1,4}){0,5}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:)))(%.+)?\s*$))/;
      if (!reg.test(value)) {
        return false;
      }
      return true;
    }
  },
  //是否mac地址
  'isMacAddress': {
    name:"mac地址",
    type:"express",
    validator(value) {
      var reg = /[A-F\d]{2}:[A-F\d]{2}:[A-F\d]{2}:[A-F\d]{2}:[A-F\d]{2}:[A-F\d]{2}/;
      if (!reg.test(value)) {
        return false;
      }
      return true;
    }
  }
}

let validate = function() {
  let args = Array.prototype.slice.call(arguments, 0);
  let validator = args[0];
  let params = args.slice(1);
  return validatorMap[validator].validator.apply(this, params);
}
validate.map = validatorMap;
export default validate;